import React from 'react';

import Icon, { IconKey } from 'flow/components/ui-components/Icon';

/* Keep in sync with the bubble's own mt-18 (72px) and h-64 (256px) below.
 * A virtualised list needs the height up front, before the bubble renders. */
export const EMPTY_BUBBLE_HEIGHT = 328;

interface Props {
    imageId: IconKey;
    title: React.ReactNode;
    message?: React.ReactNode;
}

const EmptyBubble = ({ imageId, title, message }: Props) => {
    return (
        <div className="mx-auto mt-18 flex h-64 w-64 flex-col items-center justify-center rounded-full bg-gray-100 text-center">
            <div className="flex h-full items-end justify-center">
                <Icon
                    iconKey={imageId}
                    size={'3rem'}
                    className="text-gray-300"
                />
            </div>
            <div className="mt-4 px-3 text-gray-800">{title}</div>
            <div className="flex h-full items-start justify-center px-6">
                {message}
            </div>
        </div>
    );
};

export default EmptyBubble;
